export default __webpack_public_path__ + "static/media/882156bba4becc41892ff67b1e7c5eef1578595312678.fcd07280.webp";